// extracted by mini-css-extract-plugin
export default {"market":"Coins_market__JeXPO","market_price":"Coins_market_price__mmyjr"};